const KEY = 'monsurv_dark_mode';
export const DARK_MODE_EVENT = 'monsurv-dark-mode-changed';

export function getDarkMode() {
    try {
        const raw = localStorage.getItem(KEY);
        if (raw == null) return false; // default to light (dark mode is opt-in/experimental)
        return raw === '1' || raw === 'true';
    } catch {
        return false;
    }
}

export function applyDarkClass(isDark) {
    try {
        if (isDark) document.documentElement.classList.add('dark');
        else document.documentElement.classList.remove('dark');
    } catch {
        // ignore
    }
}

export function setDarkMode(isDark) {
    try {
        localStorage.setItem(KEY, isDark ? '1' : '0');
    } catch {
        // ignore
    }

    applyDarkClass(isDark);

    try {
        window.dispatchEvent(new CustomEvent(DARK_MODE_EVENT, { detail: { dark: isDark } }));
    } catch {
        try {
            window.dispatchEvent(new Event(DARK_MODE_EVENT));
        } catch {
            // ignore
        }
    }
}

export function initDarkMode() {
    const isDark = getDarkMode();

    // Ensure the value is persisted so all tabs/components agree.
    try {
        const raw = localStorage.getItem(KEY);
        if (raw == null) localStorage.setItem(KEY, isDark ? '1' : '0');
    } catch {
        // ignore
    }

    applyDarkClass(isDark);
    return isDark;
}
